import React from 'react';
import { AuditReport } from './contentAudit.types';

interface Props {
  generatedAt?: string;
  report: AuditReport;
}

const formatDate = (iso: string) => {
  try {
    return new Date(iso).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
  } catch {
    return iso;
  }
};

// SPA fork of admin/ContentAudit/AuditSummary.
const SPAAuditSummary = ({ generatedAt, report }: Props) => {
  const { asset_count: assetCount, by_action: byAction, risk_count: riskCount } = report.summary;
  const mustEdit = byAction['Must edit'] || 0;

  const headline = riskCount === 0
    ? 'No passages flagged'
    : `${riskCount} ${riskCount === 1 ? 'passage' : 'passages'} flagged${mustEdit ? ` (${mustEdit} to edit)` : ''}`;
  const strengths = assetCount ? ` · ${assetCount} ${assetCount === 1 ? 'strength' : 'strengths'} to keep` : '';

  return (
    <div>
      <p className="tw-m-0 tw-text-base tw-leading-6">
        <span className="tw-font-semibold tw-text-spa-heading">{headline}</span>
        <span className="tw-text-spa-secondary">{strengths}</span>
      </p>
      <p className="tw-m-0 tw-mt-1 tw-text-xs tw-leading-5 tw-text-spa-secondary">
        AI review against the {report.rubric_name} rubric
        {generatedAt && ` · generated ${formatDate(generatedAt)}`}
        {' · advisory only, for editor review.'}
      </p>
    </div>
  );
};

export default SPAAuditSummary;
